import { LISTING_API_PREFIX } from 'src/common/constants';
import { EditorListing } from 'src/common/types/api/listings';
import bulkListingActionNotifications from '../bulkListingActionNotifications';
import callListingFetch, { ListingFetchResult } from '../callListingFetch';

const bulkDeleteListings = async (listings: EditorListing[]): Promise<string[]> => {
  const promises = [];
  listings.forEach((listing) => {
    const url = `${LISTING_API_PREFIX}${listing.id}`;
    promises.push(callListingFetch(listing.id, url, { method: 'DELETE' }));
  });

  const results: ListingFetchResult[] = await Promise.all(promises);
  bulkListingActionNotifications(results, listings, 'delete');
  return results.filter((r) => r.success).map((r) => r.data.id);
};

export default bulkDeleteListings;
